import { render, staticRenderFns } from "./bindCard.vue?vue&type=template&id=2ef63832&scoped=true&"
import script from "./bindCard.vue?vue&type=script&lang=js&"
export * from "./bindCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef63832",
  null
  
)

export default component.exports